export default __webpack_public_path__ + "static/B0239-ef841c2788621c5afcfe16d981cb3089.png";